/**
 * 功能说明：
 *   微信浏览器禁用下拉露出网址。
 * 使用说明：
 *   页面首次加载时，执行此函数，则会禁用所有滚动。
 *   在需要滚动的元素加上wxscrollable属性，即可使该元素支持滚动。
 *   例如<div wxscrollable></div>。
 */

export default function() {

    let touchstartY;

    document.addEventListener('touchstart', event => {
        touchstartY = event.touches[0].clientY;
    },false);

    document.addEventListener('touchmove', event => {
        let elems = Array.from(document.querySelectorAll('[wxscrollable]'));
        let matcheds = elems.filter(elem => elem.contains(event.target));
        if (!matcheds.length) {
            event.preventDefault();
        } else {
            let elem = matcheds[0];
            let scrollTop = elem.scrollTop || document.documentElement.scrollTop; // 当前滚动位置
            let clientHeight = document.documentElement.clientHeight; // 可视区域高度
            let scrollHeight = elem.scrollHeight; //元素滚动高度
            let pulldown = event.touches[0].clientY > touchstartY && scrollTop === 0 && event.cancelable;
            let pullup = scrollTop + clientHeight > scrollHeight && event.cancelable;
            if (pulldown) {
                event.preventDefault(); //禁止到顶下拉
            } else if (pullup) {
                // event.preventDefault(); //禁止到底上拉
            }
        }
    },{ passive:false });
}